import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Connects to data-controller="whats-new-modal"
export default class extends Controller {
  static values = { latestPostPublishedAtNumber: Number }

  connect() {
    const lastReadAtString = localStorage.getItem('whatsNewModalLastReadAt')
    if (lastReadAtString) {
      const lastReadAt = new Date(Number(lastReadAtString))
      const latestPostPublishedAt = new Date(this.latestPostPublishedAtNumberValue)
      if (lastReadAt < latestPostPublishedAt) {
        this.showModal()
      }
    } else {
      this.showModal()
    }
  }

  showModal() {
    new Modal(this.element).show()
    localStorage.setItem('whatsNewModalLastReadAt', this.latestPostPublishedAtNumberValue)
  }
}
